import React from "react";

// Shared drawer primitives — small building blocks used by SetupEditorDrawer
// and any other rich admin editors. Kept dumb + prop-driven so the drawers
// can compose them freely.

// Section — grouped block with an optional destination line ("Renders on: …")
// and hint. Two visual variants keep the two editor styles in lockstep:
//   • prominent (default) — large white heading, used by SetupEditorDrawer
//   • subtle              — small uppercase tracked orange eyebrow, used by
//                           PortfolioEditorDrawer + ServiceEditorDrawer
// New editors should pick one of the two — do NOT introduce a third style.
// If you need custom heading markup (e.g. inline sub-label), pass a ReactNode
// as `title`; both variants render it directly.
export const Section = ({ title, hint, destination, variant = "prominent", children }) => {
  const titleClass = variant === "subtle"
    ? "font-display text-[11px] font-bold uppercase tracking-[0.2em] text-[#FF6600]"
    : "font-display text-lg font-bold";
  return (
    <section className="mt-8 first:mt-0 space-y-4">
      <div>
        <h4 className={titleClass}>{title}</h4>
        {destination && (
          <p className="mt-1 text-[11px] italic text-[#FF6600]/80 font-medium">
            {destination}
          </p>
        )}
        {hint && <p className="text-xs text-[#A3A3A3] mt-1">{hint}</p>}
      </div>
      {children}
    </section>
  );
};

export const TextField = ({ label, value, onChange, type = "text", textarea = false, rows = 3, placeholder, hint }) => (
  <div>
    <label className="text-xs uppercase tracking-widest text-[#A3A3A3]">{label}</label>
    {textarea ? (
      <textarea
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        className="mt-2 w-full bg-[#1A1A1A] border border-[#262626] rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#FF6600] resize-none"
      />
    ) : (
      <input
        type={type}
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        className="mt-2 w-full bg-[#1A1A1A] border border-[#262626] rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-[#FF6600]"
      />
    )}
    {hint && <div className="text-[11px] text-[#A3A3A3] mt-1">{hint}</div>}
  </div>
);

export const IconBtn = ({ children, onClick, disabled, danger }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`w-9 h-9 rounded-full border grid place-items-center transition-colors ${
      disabled
        ? "border-[#1F1F1F] text-[#333] cursor-not-allowed"
        : danger
        ? "border-[#262626] hover:border-red-500 hover:text-red-500"
        : "border-[#262626] hover:border-[#FF6600] hover:text-[#FF6600]"
    }`}
  >
    {children}
  </button>
);
